var dvp = dvp || {},
    grecaptcha = grecaptcha || [],
    FullCalendar = FullCalendar || {};

( function () {
    'use strict';
    jQuery( function () {
        dvp.init();
    } );

    dvp.init = function () {
        dvp.header.init();
        dvp.animateTxt.init();
        dvp.forms.init();
        dvp.extranet.init();
        dvp.distributorHubNavigation.init();
        dvp.distributorHubInPageMenu.init();
        dvp.distributorHubSearch.init();
        dvp.distributorHubBurgerMenu.init();
        dvp.distributorHubTypeahead.init();
        dvp.distributorHubEvents.init();
        dvp.limitedProducts.init();
        dvp.verification.init();
    };
    dvp.animateTxt = {
        init: function () {
            var jTxt = jQuery( '.p-txt-animate' );
            if ( jTxt.length > 0 ) {
                dvp.animateTxt.animate();
                dvp.animateTxt.bindEvents();
            }
        },
        bindEvents: function () {
            dvp.animateTxt.isRAF = false;
            jQuery( window ).on( 'scroll', function () {
                if ( dvp.animateTxt.isRAF === false ) {
                    window.requestAnimationFrame( function () {
                        dvp.animateTxt.animate();
                        dvp.animateTxt.isRAF = false;
                    } );
                    dvp.animateTxt.isRAF = true;
                }
            } );
        },
        animate: function () {
            jQuery( '.p-txt-animate' ).each( function () {
                var jThis = jQuery( this );
                if ( e4.util.isInViewport( jThis ) === true ) {
                    jThis.addClass( 'is-visible' );
                }
            } );
        }

    };
    dvp.header = {
        isRAF: false,
        init: function () {
            dvp.header.fit();
            dvp.header.bindEvents();
            dvp.header.searchbar.bindEvents();
        },
        bindEvents: function () {

            var jBody = jQuery( 'body' ),
                intBodyScrollbarWidth = dvp.header.getBodyScrollBarWidth( jBody ),
                intMegamenuContainerScrollbarWidth = 0,
                intScrollTop = document.documentElement.scrollTop,
                boolHasBodyScrollbar = intBodyScrollbarWidth > 0 ? true : false,
                boolHasMegamenuContainerScrollbar = false;

            jQuery( window ).on( 'load resize', function () {
                if ( dvp.header.isRAF === false ) {
                    window.requestAnimationFrame( function () {
                        dvp.header.fit();
                        dvp.header.isRAF = false;
                    } );
                    dvp.header.isRAF = true;
                }
            } );
            jQuery( '.e-dropdown-mega' ).on( 'shown.bs.dropdown hidden.bs.dropdown', function ( e ) {
                if ( e.relatedTarget.localName !== 'button' ) {
                    if ( e.type === 'shown' && boolHasBodyScrollbar ) {
                        intMegamenuContainerScrollbarWidth = dvp.header.getElementScrollBarWidth( jQuery( e.target ).find( '.e-megamenu-container' ) );

                        boolHasMegamenuContainerScrollbar = intMegamenuContainerScrollbarWidth > 0 ? true : false;

                        if ( boolHasMegamenuContainerScrollbar ) {
                            intScrollTop = document.documentElement.scrollTop;
                            jBody.addClass( 'no-sroll' );
                        }
                    }
                    else if ( e.type === 'hidden' && boolHasBodyScrollbar ) {
                        if ( boolHasMegamenuContainerScrollbar ) {
                            jBody.removeClass( 'no-sroll' );
                            document.documentElement.scrollTop = intScrollTop;
                        }
                    }
                }
            } );
        },
        getBodyScrollBarWidth: function ( jElement ) {

            var intCurrentWidth = jElement.width();

            jElement.css( 'overflow', 'hidden' );
            var intScrollbarWidth = jElement.width() - intCurrentWidth;
            jElement.css( 'overflow', '' );

            return intScrollbarWidth;
        },
        getElementScrollBarWidth: function ( jElement ) {

            var intCurrentWidth = jElement[ 0 ].scrollWidth,
                intOffsetWidth = jElement[ 0 ].offsetWidth;

            var intScrollbarWidth = intOffsetWidth - intCurrentWidth;

            return intScrollbarWidth;
        },
        fit: function () {
            var jHeader = jQuery( '.js-e-header' ),
                jCanvas = jQuery( '#js-e-canvas' ),
                jMegamenuContainer = jQuery( '.e-megamenu-container' );

            for ( var i = 0; i < 5; i++ ) {
                setTimeout( function () {
                    jCanvas.css( 'padding-top', Math.floor( jHeader.height() - 1 ) );
                }, 60 * i );
            }
            if ( window.innerWidth > 991 ) {
                jMegamenuContainer.css( 'max-height', Math.floor( jQuery( window ).height() - jHeader.height() ) );
            }
        },
        searchbar: {
            bindEvents: function () {
                jQuery( '.js-dvp-typeahead-form' ).on( 'submit', function ( e ) {
                    e.preventDefault();
                    var dvpSearchbarValue = jQuery( '.js-dvp-header-search-input' ).val();
                    e4.util.hash.set( 'search', dvpSearchbarValue );
                } ).find( '.js-dvp-header-search-input' ).on( 'input', function () {
                    dvp.header.searchbar.toggleInputGroupState( this );
                } );
                jQuery( '.js-trigger-search' ).on( 'click', function ( e ) {
                    e.preventDefault();
                    jQuery( '.js-dvp-typeahead-form' ).trigger( 'submit' );
                } );
                jQuery( '.js-dvp-search-clear' ).on( 'click', function () {
                    dvp.header.searchbar.clearInput( this );
                } );
            },
            toggleInputGroupState: function ( domElm ) {
                var jSearchInputGroup = jQuery( domElm ).closest( '.js-dvp-search-container' ).find( '.js-dvp-search-action-group' );
                if ( domElm.value === '' ) {
                    jSearchInputGroup.addClass( 'is-empty' );
                }
                else {
                    jSearchInputGroup.removeClass( 'is-empty' );
                }
            },
            clearInput: function ( domElm ) {
                jQuery( domElm ).closest( '.js-dvp-search-container' ).find( '.js-dvp-header-search-input' ).val( '' ).trigger( 'focus' ).triggerHandler( 'input' );
            }
        }
    };
    dvp.flexTables = {
        init: function () {
            dvp.flexTables.addStripes();
        },
        addStripes: function () {
            jQuery( '.flex-table--stripe' ).each( function () {
                jQuery( this ).find( '.cell' ).each( function () {
                    var order = jQuery( this ).attr( 'style' ).match( /\d+/g )[ 0 ];
                    if ( order % 2 === 0 ) {
                        jQuery( this ).addClass( 'is-striped' );
                    }
                } );
            } );
        }
    };
    dvp.utilities = {
        copyToClipboard: function () {
            jQuery( '.js-copy-to-clipboard' ).on( 'click', function () {
                var temp = jQuery( '<input>' );
                jQuery( 'body' ).append( temp );
                temp.val( jQuery( this ).attr( 'href' ) ).select();
                document.execCommand( 'copy' );
                temp.remove();
            } );
        },
        printElement: function () {
            jQuery( '.js-print' ).on( 'click', function () {
                window.print();
            } );
        },
        init: function () {
            dvp.utilities.copyToClipboard();
        }
    };
    dvp.forms = {
        bindEvents: function () {
            jQuery( '.js-e-form-dw' ).each( function () {
                if ( jQuery( this ).find( 'select[name="MailRecipient"]' ).length > 0 && jQuery( this ).find( 'input[name="MailRecipientLabel"]' ).length > 0 ) {
                    var jMailRecipientLabelField = jQuery( this ).find( 'input[name="MailRecipientLabel"]' );

                    jQuery( this ).on( 'change', 'select[name="MailRecipient"]', function () {
                        jMailRecipientLabelField.val( jQuery( 'option:selected', this ).text().trim() );
                    } );
                }
            } );
        },
        init: function () {
            if ( jQuery( '.js-e-form-dw' ).length > 0 ) {
                dvp.forms.bindEvents();
            }
        }
    };
    dvp.extranet = {
        addRules: function () {
            jQuery.validator.addMethod( 'userregex', function ( value, element, regexp ) {
                var re = new RegExp( regexp );
                return this.optional( element ) || re.test( value );
            } );
        },
        addValidation: function () {
            var jExtranetForms = jQuery( 'form[name="UserManagementEditForm"], .js-validate-password-recovery' );
            jExtranetForms.validate( {
                ignore: '.ignore',
                rules: {
                    AccessUserEmail: {
                        required: true,
                        email: true
                    },
                    UserManagement_Form_Email: {
                        required: true,
                        email: true
                    },
                    UserManagement_Form_UserName: {
                        required: true,
                        userregex: '^[a-zA-Z0-9_-]{3,50}$'
                    },
                    UserManagement_Form_OldPassword: {
                        required: function () {
                            return jQuery( 'input[name="UserManagement_Form_NewPassword"]' ).val().length !== 0;
                        }
                    },
                    UserManagement_Form_NewPassword: {
                        minlength: 6,
                    },
                    UserManagement_Form_NewPasswordConfirm: {
                        equalTo: 'input[name="UserManagement_Form_NewPassword"]'
                    },
                    hiddenRecaptcha: {
                        required: function () {
                            if ( grecaptcha.getResponse() === '' ) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        }
                    }
                },
                groups: {
                    UserManagement_Form_Zip: 'UserManagement_Form_Zip UserManagement_Form_City'
                },
                validClass: 'is-valid',
                errorClass: 'is-invalid',
                focusInvalid: false,
                highlight: function ( domElm, strClassError /*, strClassValid */ ) {
                    jQuery( domElm ).addClass( strClassError ).closest( '.form-fields' ).addClass( strClassError );
                },
                unhighlight: function ( domElm, strClassError /*, strClassValid */ ) {
                    jQuery( domElm ).removeClass( strClassError ).closest( '.form-fields' ).removeClass( strClassError );
                },
                errorPlacement: function ( jError, jElement ) {
                    var jFormGroup = jElement.closest( '.form-fields' );
                    jError.addClass( 'form-text small invalid-feedback' );
                    jFormGroup.append( jError );
                },
                invalidHandler: function ( form, validator ) {
                    var jFirstError = jQuery( validator.invalidElements()[ 0 ] );
                    if ( e4.util.isInViewport( jFirstError ) === true ) {
                        validator.focusInvalid();
                    }
                    else {
                        jFirstError.focus();
                        e4.scrollToAnchor.animate( jFirstError.closest( '.form-fields' ).offset().top * 0.875, e4.nav.global.hide );
                    }
                },
                submitHandler: function ( form ) {
                    if ( form.UserManagement_Form_NewPassword.value === '' && form.UserManagement_Form_NewPasswordConfirm.value === '' ) {
                        jExtranetForms.find( ':password' ).prop( 'disabled', true );
                    }
                    else {
                        jExtranetForms.find( ':password' ).filter( function () {
                            return this.value === '';
                        } ).prop( 'disabled', true );
                    }
                    form.submit();
                }
            } );
            if ( jQuery( 'input[name="UserManagement_Form_OldPassword"]' ).length === 1 ) {
                jQuery( 'input[name="UserManagement_Form_NewPassword"]' ).on( 'change keyup', function () {
                    jQuery( 'input[name="UserManagement_Form_OldPassword"]' ).valid();
                } );
            }
        },
        loadTranslations: function () {
            var strLang = e4.settings.lang;
            if ( strLang !== 'en' ) {
                if ( strLang === 'nb' || strLang === 'nn' ) {
                    strLang = 'no';
                }
                else if ( strLang === 'se' ) {
                    strLang = 'sv';
                }
                // Load validation messages from cdn, and then extend if custom messages are set.
                e4.util.require.js( {
                    url: '//ajax.aspnetcdn.com/ajax/jquery.validate/1.17.0/localization/messages_' + strLang + '.js',
                    fallback: '/files/system/espresso/design/js/vendor/jquery.validate.messages_' + strLang + '.js',
                    callback: function () {
                        dvp.extranet.extendTranslations( strLang );
                    }
                } );
            }
            else {
                dvp.extranet.extendTranslations( strLang );
            }
        },
        extendTranslations: function ( strLang ) {
            if ( e4.settings.forms.validate.messages[ strLang ] !== undefined ) {
                jQuery.extend( jQuery.validator.messages, e4.settings.forms.validate.messages[ strLang ] );
            }
        },
        countrySelector: {
            warningMessage: function () {
                var jDechraUserCountrySelector = jQuery( '.js-dechra-user-country-selector' );

                if ( jDechraUserCountrySelector.length > 0 ) {
                    jDechraUserCountrySelector.on( 'change', function () {
                        var strCurrentCountryCode = jQuery( this ).data( 'current-country-code' ),
                            strSelectedCountryCode = this.value;

                        jQuery( '.js-dechra-country-warning-message' ).addClass( 'd-none' );

                        if ( strCurrentCountryCode !== strSelectedCountryCode ) {
                            jQuery( '.js-dechra-country-warning-message' ).removeClass( 'd-none' );
                        }
                    } ).triggerHandler( 'change' );
                }
            }
        },
        editing: {
            checkboxes: function () {
                jQuery( 'form' ).on( 'change', '.js-dechra-checkbox-edit', function () {
                    var jThis = jQuery( this ),
                        strInputName = jThis.data( 'name' ),
                        boolCheckboxState = jThis.is( ':checked' );

                    jQuery( 'input[name="' + strInputName + '"]' ).val( boolCheckboxState ? 'True' : '' );
                } );
            },
            bindEvents: function () {
                dvp.extranet.editing.checkboxes();
            }
        },
        tracking: function () {
            if ( jQuery( '.js-track-new-user-preparation' ).length > 0 && localStorage.getItem( 'DvpNewUser' ) === null ) {
                localStorage.setItem( 'DvpNewUser', true );
            }
            if ( jQuery( '.js-track-new-user-trigger' ).length > 0 && localStorage.getItem( 'DvpNewUser' ) !== null && localStorage.getItem( 'DvpNewUser' ) === 'true' ) {
                localStorage.setItem( 'DvpNewUser', false );
                e4.gtm.pushDataLayer( {
                    'eventCategory': 'dvp-registration',
                    'eventAction': 'register',
                    'eventLabel': 'new-user',
                    'eventValue': 0,
                    'eventInteraction': true,
                    'event': 'track-ga-event'
                } );
            }
        },
        login: function () {
            jQuery( 'body' ).on( 'click', '.js-dvp-extranet-login', function () {
                if ( jQuery( this ).hasClass( 'js-dvp-extranet-login-premium-content' ) ) {
                    jQuery( '.dvp-login-modal' ).find( '.js-dvp-login-modal-premium-content' ).removeClass( 'd-none' );
                }
                jQuery( '.dvp-login-modal' ).modal( 'show' );
            } );
            if ( jQuery( '.js-dvp-login-modal-error' ).length > 0 ) {
                jQuery( '.dvp-login-modal' ).modal( 'show' );
            }
            jQuery( '.dvp-login-modal' ).on( 'shown.bs.modal', function () {
                jQuery( 'input', this ).first().focus();
            } );
            jQuery( '.dvp-login-modal' ).on( 'hidden.bs.modal', function () {
                jQuery( '.dvp-login-modal' ).find( '.js-dvp-login-modal-premium-content' ).addClass( 'd-none' );
                if ( jQuery( '.modal.fade:visible' ).length ) {
                    jQuery( 'body' ).addClass( 'modal-open' );
                }
            } );
        },
        init: function () {
            dvp.extranet.login();
            dvp.extranet.tracking();
            e4.util.require.js( e4.settings.require.jQueryValidate, function () {
                dvp.extranet.loadTranslations();
                dvp.extranet.addRules();
                dvp.extranet.addValidation();
            } );
            dvp.extranet.countrySelector.warningMessage();
            dvp.extranet.editing.bindEvents();
            if ( jQuery( '.js-hiddenRecaptcha' ).length > 0 ) {
                e4.util.require.js( {
                    url: '//www.google.com/recaptcha/api.js',
                    fallback: ''
                } );
            }
        }
    };
    dvp.distributorHubNavigation = {
        strDistributorHubSidebarMenuLink: '.js-distributor-hub-sidebar-menu-link',
        strDistributorHubSidebarNavigationContainerText: '.js-distributor-hub-sidebar-page-navigation-container-text',
        strDistributorHubSidebarNavigationWrapper: '.js-distributor-hub-sidebar-page-navigation-wrapper',
        data: null,
        groupId: jQuery( '.js-distributor-hub-left-menu' ).data( 'groupid' ),
        pageId: jQuery( '.js-distributor-hub-left-menu' ).data( 'pageid' ),
        get: function () {
            jQuery.ajax( {
                url: '/system/data/navigation',
                data: {
                    dhGroupID: dvp.distributorHubNavigation.groupId,
                    dhPageID: dvp.distributorHubNavigation.pageId
                },
                method: 'GET',
                dataType: 'json',
                cache: false,
                success: function ( data ) {
                    dvp.distributorHubNavigation.data = data;
                    dvp.distributorHubNavigation.update();
                }
            } );
        },
        update: function () {
            jQuery( '.js-distributor-hub-left-menu' ).html( e4.handlebars.tmpl.distributorHubLeftMenu( dvp.distributorHubNavigation.data ) );
            jQuery( '.js-distributor-hub-previous-next-navigation' ).html( e4.handlebars.tmpl.distributorHubPreviousNextNavigation( dvp.distributorHubNavigation.data ) );
            jQuery( '.js-distributor-hub-sidebar-page-navigation-container' ).html( e4.handlebars.tmpl.distributorHubSidebarPageNavigation( dvp.distributorHubNavigation.data ) );
        },
        bindEvents: function () {

            jQuery( dvp.distributorHubNavigation.strDistributorHubSidebarMenuLink ).on( 'click', function ( e ) {
                e.stopPropagation();
                e.preventDefault();
                if ( dvp.distributorHubNavigation.data !== null ) {
                    dvp.distributorHubBurgerMenu.hideSidebar();
                    jQuery( dvp.distributorHubNavigation.strDistributorHubSidebarMenuLink ).not( this ).removeClass( 'open' );
                    jQuery( dvp.distributorHubNavigation.strDistributorHubSidebarNavigationContainerText ).find( '.shown' ).hide();
                    if ( !jQuery( this ).hasClass( 'open' ) ) {
                        jQuery( this ).addClass( 'open' );
                        jQuery( '#' + jQuery( this ).data( 'id' ) ).addClass( 'shown' ).fadeIn();
                        jQuery( dvp.distributorHubNavigation.strDistributorHubSidebarNavigationWrapper ).addClass( 'open' );
                    }
                    else {
                        jQuery( this ).removeClass( 'open' );
                        jQuery( dvp.distributorHubNavigation.strDistributorHubSidebarNavigationWrapper ).removeClass( 'open' );
                    }
                }
            } );
            jQuery( dvp.distributorHubNavigation.strDistributorHubSidebarNavigationWrapper ).on( 'click', function ( e ) {
                e.stopPropagation();
            } );
            jQuery( document ).on( 'click', function () {
                if ( jQuery( this ) !== jQuery( dvp.distributorHubNavigation.strDistributorHubSidebarNavigationWrapper ) ) {
                    dvp.distributorHubNavigation.hideSidebar();
                }
            } );
        },
        hideSidebar: function () {
            jQuery( dvp.distributorHubNavigation.strDistributorHubSidebarMenuLink ).removeClass( 'open' );
            jQuery( dvp.distributorHubNavigation.strDistributorHubSidebarNavigationContainerText ).find( '.shown' ).hide();
            jQuery( dvp.distributorHubNavigation.strDistributorHubSidebarNavigationWrapper ).removeClass( 'open' );
        },
        init: function () {
            if ( jQuery( '.js-distributor-hub-left-menu' ).length > 0 ) {
                e4.util.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerHelpers( 'compare' );
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-distributor-hub-left-menu' );
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-distributor-hub-previous-next-navigation' );
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-distributor-hub-sidebar-page-navigation' );
                    dvp.distributorHubNavigation.bindEvents();
                    dvp.distributorHubNavigation.get();
                } );
            }
        }
    };
    dvp.distributorHubInPageMenu = {
        collectionForMenu: [],
        collectionForHighlight: [],
        collectionLastId: '',
        hideMenu: true,
        collect: function () {
            jQuery( '#dwcontent-main .e-section .container-fluid h1, #dwcontent-main .e-section .container-fluid h2, #dwcontent-main .e-section .container-fluid h3' ).each( function ( index ) {
                if ( jQuery( this ).text().trim() !== '' ) {
                    var inPageHeaderId = 'in-page-header-' + index;
                    var header = {
                        'Text': jQuery( this ).text(),
                        'Type': jQuery( this ).prop('tagName'),
                        'Id': inPageHeaderId
                    };
                    jQuery( this ).attr( 'id', inPageHeaderId );
                    dvp.distributorHubInPageMenu.collectionForMenu.push( header );
                    dvp.distributorHubInPageMenu.collectionForHighlight.push( jQuery( this ) );
                    if ( !e4.util.isInViewport( jQuery( this ) ) ) {
                        dvp.distributorHubInPageMenu.hideMenu = e4.util.isInViewport( jQuery( this ) );
                    }
                }
            } );
        },
        build: function () {
            if ( !dvp.distributorHubInPageMenu.hideMenu ) {
                jQuery( '.js-distributor-hub-in-page-navigation' ).html( e4.handlebars.tmpl.distributorHubInPageNavigation( { Header: dvp.distributorHubInPageMenu.collectionForMenu } ) );
                dvp.distributorHubInPageMenu.bindEvents();
            }
        },
        bindEvents: function () {
            e4.scrollToAnchor.bindEvents();

            jQuery( window ).scroll( function () {

                var currentScroll = jQuery( window ).scrollTop(),
                    currentHeader = [];

                dvp.distributorHubInPageMenu.collectionForHighlight.map( function ( item ) {
                    if ( ( item.offset().top - 40 ) < currentScroll ) {
                        currentHeader.push( item );
                    }
                } );

                if ( currentHeader.length > 0 ) {

                    currentHeader = currentHeader[ currentHeader.length - 1 ];

                    if ( dvp.distributorHubInPageMenu.collectionLastId !== currentHeader.attr( 'id' ) ) {
                        dvp.distributorHubInPageMenu.collectionLastId = currentHeader.attr( 'id' );

                        jQuery( '.js-distributor-hub-in-page-navigation-link.active' ).removeClass( 'active' );
                        jQuery( '.js-distributor-hub-in-page-navigation' ).find( '.js-distributor-hub-in-page-navigation-link[data-id="' + currentHeader.attr( 'id' ) + '"]' ).addClass( 'active' );
                    }
                }
            } );
        },
        init: function () {
            if ( jQuery( '.js-distributor-hub-in-page-navigation' ).length > 0 && (jQuery( '.js-distributor-hub-in-page-navigation' ).parent().siblings().hasClass( 'col-lg-9' ) || jQuery( '.js-distributor-hub-in-page-navigation' ).parent().siblings().hasClass( 'col-lg-8' )) ) {
                e4.util.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-distributor-hub-in-page-navigation' );
                    dvp.distributorHubInPageMenu.collect();
                    dvp.distributorHubInPageMenu.build();
                } );
            }
        }
    };
    dvp.distributorHubSearch = {
        strDistributorHubSearchClass: '.js-distributor-hub-search',
        strDistributorHubSearchButtonClass: '.js-distributor-hub-search-button',
        strDistributorHubSearchInputClass: '.js-distributor-hub-search-input',
        bindEvents: function () {
            jQuery( dvp.distributorHubSearch.strDistributorHubSearchButtonClass ).on( 'click', function ( e ) {
                e.stopPropagation();
                dvp.distributorHubNavigation.hideSidebar();
                dvp.distributorHubBurgerMenu.hideSidebar();
                jQuery( dvp.distributorHubSearch.strDistributorHubSearchClass ).parent().toggleClass( 'open' );
                jQuery( dvp.distributorHubSearch.strDistributorHubSearchInputClass ).toggleClass( 'd-none' ).focus();
            } );
            jQuery( dvp.distributorHubSearch.strDistributorHubSearchClass ).on( 'click', function ( e ) {
                e.stopPropagation();
            } );
            jQuery( document ).on( 'click', function () {
                jQuery( dvp.distributorHubSearch.strDistributorHubSearchClass ).parent().removeClass( 'open' );
                jQuery( dvp.distributorHubSearch.strDistributorHubSearchInputClass ).addClass( 'd-none' );
            } );
        },
        init: function () {
            if ( jQuery( dvp.distributorHubSearch.strDistributorHubSearchInputClass ).length > 0 ) {
                dvp.distributorHubSearch.bindEvents();
            }
        }
    };

    dvp.distributorHubBurgerMenu = {
        strDistributorHubBurgerMenuButtonClass: '.js-distributor-hub-burger-menu-button',
        strDistributorHubLeftMenuWrapper: '.js-distributor-hub-left-menu-wrapper',
        bindEvents: function () {
            jQuery( dvp.distributorHubBurgerMenu.strDistributorHubBurgerMenuButtonClass ).on( 'click', function ( e ) {
                e.stopPropagation();
                e.preventDefault();
                dvp.distributorHubNavigation.hideSidebar();
                if ( !jQuery( this ).hasClass( 'open' ) ) {
                    jQuery( this ).addClass( 'open' );
                    jQuery( dvp.distributorHubBurgerMenu.strDistributorHubLeftMenuWrapper ).addClass( 'open' );
                }
                else {
                    jQuery( this ).removeClass( 'open' );
                    jQuery( dvp.distributorHubBurgerMenu.strDistributorHubLeftMenuWrapper ).removeClass( 'open' );
                }
            } );
            jQuery( dvp.distributorHubBurgerMenu.strDistributorHubLeftMenuWrapper ).on( 'click', function ( e ) {
                e.stopPropagation();
            } );
            jQuery( document ).on( 'click', function () {
                if ( jQuery( this ) !== jQuery( dvp.distributorHubBurgerMenu.strDistributorHubLeftMenuWrapper ) ) {
                    dvp.distributorHubBurgerMenu.hideSidebar();
                }
            } );
        },
        hideSidebar: function () {
            jQuery( dvp.distributorHubBurgerMenu.strDistributorHubBurgerMenuButtonClass ).removeClass( 'open' );
            jQuery( dvp.distributorHubBurgerMenu.strDistributorHubLeftMenuWrapper ).removeClass( 'open' );
        },
        init: function () {
            if ( jQuery( dvp.distributorHubBurgerMenu.strDistributorHubBurgerMenuButtonClass ).length > 0 ) {
                dvp.distributorHubBurgerMenu.bindEvents();
            }
        }
    };

    dvp.distributorHubTypeahead = {
        init: function () {
            if ( jQuery( '.js-distributor-hub-search-input' ).length > 0 ) {
                e4.util.require.js( e4.settings.require.typeahead, function () {
                    dvp.distributorHubTypeahead.bindEvents();
                } );
            }
        },
        bindEvents: function () {
            jQuery( '.js-distributor-hub-search-input' ).typeahead( {
                hint: false,
                highlight: true,
                minLength: 2,
                classNames: {
                    wrapper: 'dvp-typeahead-wrapper js-dvp-typeahead-wrapper w-100',
                    input: 'js-distributor-hub-search-input',
                    menu: 'js-dvp-suggestions dvp-suggestions dropdown-menu w-100',
                    suggestion: 'js-dvp-suggestions-item dropdown-item',
                    open: 'open',
                    cursor: 'active',
                    highlight: 'active'
                }
            }, {
                name: 'typeahead',
                limit: 8,
                async: true,
                source: function ( query, syncResults, asyncResults ) {
                    dvp.distributorHubTypeahead.getSuggestions( query, function ( data ) {
                        asyncResults( data );
                    } );
                },
                display: function ( suggestion ) {
                    return suggestion.range;
                }
            } ).on( 'typeahead:autocomplete typeahead:select', function ( event, suggestion ) { // typeahead:cursorchange
                if ( suggestion !== null ) {
                    window.location.href = suggestion.url;
                }
            } );
        },
        getSuggestions: function ( query, asyncResults ) {
            if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
                this.jqXHR.abort();
            }
            query = jQuery.trim( query );
            if ( query !== '' ) {
                this.jqXHR = jQuery.ajax( {
                    type: 'GET',
                    url: '/system/data/search',
                    data: {
                        q: query
                    },
                    dataType: 'json'
                } );
                this.jqXHR.done( function ( data ) {
                    asyncResults( data );
                } );
            }
        }
    };
    dvp.distributorHubEvents = {
        calendar: function () {
            jQuery.ajax( {
                url: e4.settings.search.events.url,
                method: 'GET',
                dataType: 'json',
                cache: false,
                success: function ( data ) {
                    var calendarEl = document.getElementById( 'calendar' );
                    var calendar = new FullCalendar.Calendar( calendarEl, { 
                        locale: e4.settings.lang,
                        height: 'auto',
                        headerToolbar: {
                            left: 'prev,next today',
                            center: 'title',
                            right: 'dayGridMonth timeGridWeek'
                        },
                        nextDayThreshold: '00:00:00',
                        editable: false,
                        events: data,
                        displayEventTime: false,
                        eventDidMount: function ( info ) {
                            if ( info.event.extendedProps && info.event.extendedProps.category ) {
                                info.el.setAttribute( 'data-category', info.event.extendedProps.category );
                                info.el.classList.add( 'cursor-pointer' );

                                jQuery( info.el ).on( 'click', function () {
                                    jQuery( '.js-distributor-hub-calendar-content' ).html( e4.handlebars.tmpl.distributorHubCalendarContent( info.event ) );
                                    jQuery( '.distributor-hub-calendar-modal' ).modal();
                                    jQuery( info.el ).popover( 'hide' );
                                } );

                                jQuery( info.el ).popover( {
                                    title: info.event.title,
                                    content: info.event.extendedProps.excerpt,
                                    html: true,
                                    placement: 'top',
                                    trigger: 'hover',
                                    template: '<div class="popover" role="tooltip"><div class="arrow"></div><p class="popover-header h4 mt-0 text-white"></p><div class="popover-body small text-white text-truncate"></div></div>',
                                    container: '.fc-view-harness'
                                } );
                            }
                        },
                    } );
                    calendar.render();
                }
            } );
        },
        filterEvent: function () {
            jQuery( '.js-event-filter' ).find( '.nav-link' ).on( 'click', function () {
                jQuery( '.js-event-filter' ).find( '.nav-link' ).removeClass( 'active' );
                jQuery( this ).addClass( 'active' );
                dvp.distributorHubEvents.filter( jQuery( this ) );
            } );
        },
        filter: function ( jElem ) {
            var category = jElem.data( 'label' );
            if ( category !== 'all' ) {
                jQuery( '.fc-event' ).fadeOut( 'fast' );
                jQuery( '.fc-event[data-category="' + category + '"]' ).fadeIn( 'fast' );
            }
            else {
                jQuery( '.fc-event' ).fadeIn( 'fast' );
            }
        },
        init: function () {
            if ( jQuery( '#calendar' ).length > 0 ) {
                var events = {},
                    strEventFilterClass = '.js-event-filter';
                jQuery( strEventFilterClass ).find( 'li' ).each( function () {
                    var cat = jQuery( this ).find( '.nav-link' ).data( 'label' );
                    if ( events[ cat ] ) {
                        jQuery( this ).remove();
                    }
                    else {
                        events[ cat ] = true;
                    }
                } );
                jQuery( strEventFilterClass ).removeClass( 'd-none' );
                e4.util.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-distributor-hub-calendar-content' );
                    dvp.distributorHubEvents.calendar();
                    dvp.distributorHubEvents.filterEvent();
                } );
            }
        }
    };
    dvp.limitedProducts = {
        data: null,
        url: '/system/data/limitedproducts',
        get: function ( jForm ) {
            jQuery.ajax( {
                url: dvp.limitedProducts.url,
                method: 'GET',
                data: jForm.serialize(),
                dataType: 'json',
                cache: false,
                success: function ( data ) {
                    dvp.limitedProducts.data = data;
                    dvp.limitedProducts.update();
                }
            } );
        },
        update: function () {
            jQuery( '.js-distributor-limited-product-view' ).html( e4.handlebars.tmpl.distributorHubProductListLimited( dvp.limitedProducts.data ) );
        },
        bindings: function () {
            jQuery( '.js-distributor-limited-product-view' ).on( 'submit', '.js-e-productlist-form', function ( e ) {
                e.preventDefault();
                dvp.limitedProducts.get( jQuery( this ) );
            } );
        },
        init: function () {
            if ( jQuery( '.js-distributor-limited-product-view' ).length > 0 ) {
                e4.util.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-distributor-hub-product-list-limited' );
                    dvp.limitedProducts.get( jQuery( '.js-distributor-limited-product-view' ).find( '.js-e-productlist-form' ) );
                    dvp.limitedProducts.bindings();
                } );
            }
        }
    };
    dvp.getPositions = {
        fromTopWindow: function ( strElement ) {
            var scrollTop = jQuery( window ).scrollTop(),
                elementOffset = jQuery( strElement ).offset().top;

            return ( elementOffset - scrollTop );
        }
    };
    dvp.verification = {
        preventResend: function () {
            if ( window.history.replaceState ) {
                window.history.replaceState( null, null, window.location.href );
            }
        },
        init: function () {
            dvp.verification.preventResend();
        }
    };
}() );
